'use client';

import { css } from '@onbeam/business-styled-system/css';
import { vstack } from '@onbeam/business-styled-system/patterns';
import { AnimatePresence, motion } from 'motion/react';
import { MobileSubNavProps } from './MobileSubNav.types';
import { Button } from '@onbeam/business-ui';
import { useMobileNavigation } from '../MobileNavigation.store';
import { FocusTrap } from '@/components/shared/FocusTrap';
import { ChevronRightIcon } from '@onbeam/icons/business';

export const MobileSubNav = ({
  isOpen,
  onClose,
  children,
}: MobileSubNavProps) => {
  const { isOpen: isHeaderOpen } = useMobileNavigation();

  return (
    <AnimatePresence>
      {isOpen && (
        <FocusTrap>
          <motion.div
            initial={{ x: '100%', opacity: 0.5 }}
            animate={{
              x: '0%',
              opacity: 1,
              y: isHeaderOpen ? 0 : '-100dvh',
            }}
            transition={{
              delay: isHeaderOpen ? 0 : 0.15,
              duration: 0.25,
              ease: 'easeOut',
            }}
            exit={{ x: '100%', opacity: 0.5 }}
            className={vstack({
              pointerEvents: 'all',
              position: 'fixed',
              inset: '0',
              p: '6',
              zIndex: 150,
              bg: 'mono.primaryFg',
            })}
          >
            <Button
              variant="ghost"
              size="md"
              onClick={onClose}
              className={css({
                w: 'fit',
                transform: 'translate(-1rem, -0.3125rem)',
              })}
              iconLeft={
                <ChevronRightIcon
                  className={css({ transform: 'rotate(180deg)' })}
                />
              }
            >
              Back
            </Button>
            <div
              className={vstack({
                mt: '10',
                overflowY: 'auto',
              })}
            >
              {children}
            </div>
          </motion.div>
        </FocusTrap>
      )}
    </AnimatePresence>
  );
};
